import {
  HTTP_GETBUDGETFA_FETCHING,
  HTTP_GETBUDGETFA_SUCCESS,
  HTTP_GETBUDGETFA_FAILED,
  server,
  OK,
  YES,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const setStateBudgetFaToFetching = () => ({
  type: HTTP_GETBUDGETFA_FETCHING,
});

export const setStateBudgetFaToSuccess = (payload) => ({
  type: HTTP_GETBUDGETFA_SUCCESS,
  payload,
});

export const setStateBudgetFaToFailed = (payload) => ({
  type: HTTP_GETBUDGETFA_FAILED,
});

export const clearBudgetfa = () => {
  return async (dispatch) => {
    dispatch(setStateBudgetFaToSuccess([]));
  };
};

export const getBudgetFa = (country, company, brand, depts, year, secid) => {
  return async (dispatch) => {
    dispatch(setStateBudgetFaToFetching());
    try {
      const result = await httpClient.get(
        `${server.GETBUDGETFA_URL}/${country}/${company}/${brand}/${depts}/${year}/${secid}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(setStateBudgetFaToSuccess(result.data));
      return Promise.resolve(result.data[0]);
    } catch (error) {
      dispatch(setStateBudgetFaToFailed());
    }
  };
};
